import { inicioGuard, moduloGuard } from '@intelishs-group/session-core';
import { Routes } from '@angular/router';
import { DashboardPage } from './pages/dashboard/dashboard.page';

export const routes: Routes = [
  {
    // Al entrar: la PRIMERA pantalla del acceso (el primer módulo por su orden en identidad),
    // no un destino fijo.
    path: '',
    pathMatch: 'full',
    canActivate: [inicioGuard()],
    children: [],
  },
  {
    // Una pantalla más. Iba sin guard porque era el destino de `rutaSinPermiso`; la aplicación
    // `herramientas` no tiene el módulo `dashboard`, así que hoy no la abre nadie (tampoco estaba
    // en el menú).
    path: 'dashboard',
    canActivate: [moduloGuard('dashboard')],
    component: DashboardPage,
  },
  {
    path: 'herramientas',
    canActivate: [moduloGuard('herramientas')],
    loadComponent: () =>
      import('./pages/herramientas/herramientas.page').then((m) => m.HerramientasPage),
  },
  // Cada herramienta es un modulo lazy independiente. Al agregar una nueva:
  // 1) crear la carpeta en pages/herramientas/<id>/
  // 2) registrar la ruta aqui
  // 3) darla de alta en pages/herramientas/herramientas.registry.ts
  {
    path: 'herramientas/xlsx-a-csv',
    canActivate: [moduloGuard('herramientas')],
    loadComponent: () =>
      import('./pages/herramientas/xlsx-a-csv/xlsx-a-csv.page').then((m) => m.XlsxACsvPage),
  },
  {
    // Lo que no existe vuelve a la primera pantalla del acceso. `children: []` y no
    // `redirectTo`: una redirección no corre guards.
    path: '**',
    canActivate: [inicioGuard()],
    children: [],
  },
];
